import { s as _defineProperty } from "./fold-CB4fAOOy.js";
//#region src/promise/AbortError.ts
var AbortError = class extends Error {
	constructor(reason) {
		super(reasonMessage(reason));
		_defineProperty(this, "name", "AbortError");
		_defineProperty(this, "reason", void 0);
		this.reason = reason;
	}
};
function isAbortError(value) {
	return value instanceof AbortError || value?.name === "AbortError";
}
function reasonMessage(reason) {
	if (reason == null) return "aborted";
	if (typeof reason === "string") return reason;
	if (reason instanceof Error) return reason.message || "aborted";
	try {
		return JSON.stringify(reason);
	} catch {
		return "aborted";
	}
}
//#endregion
export { isAbortError as n, AbortError as t };

//# sourceMappingURL=AbortError-CjSasIlL.js.map